import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=c331411c&scoped=true&"
import script from "./Assignment.vue?vue&type=script&lang=js&"
export * from "./Assignment.vue?vue&type=script&lang=js&"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=c331411c&prod&scoped=true&lang=css&"
import style1 from "./Assignment.vue?vue&type=style&index=1&id=c331411c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c331411c",
  null
  
)

export default component.exports